import { render, staticRenderFns } from "./CardApontamento.vue?vue&type=template&id=417f1b50&scoped=true"
import script from "./CardApontamento.vue?vue&type=script&lang=js"
export * from "./CardApontamento.vue?vue&type=script&lang=js"
import style0 from "./CardApontamento.vue?vue&type=style&index=0&id=417f1b50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417f1b50",
  null
  
)

export default component.exports